import React, { Component } from "react";
import ComponentHeader from "./ComponentHeader";
import classnames from "classnames";
import styles from "./Components.local.scss";
import { number_format } from "Utils";
import _ from "i18n";
import ComponentActions from "./ComponentActions";

class BarometerAndValueComponent extends Component {
  render() {
    const {
      slideId,
      isPreparePresentation,
      component,
      isPresentation,
      hasComments,
      isComposition,
      indicatorsExplanation,
      hasExplanation
    } = this.props;

    const {
      componentId,
      labels,
      data: { account },
      config: { annexeAttachmentCategory }
    } = component;

    const { percentage, currentValue, unit, status, notAvailable } = account[0];

    const barometerState =
      status === 1 ? "superior" : status === -1 ? "inferior" : "average";

    return (
      <div>
        <ComponentHeader
          slideId={slideId}
          percentage={percentage}
          title={labels}
          annexeAttachmentCategory={annexeAttachmentCategory}
          handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
          isComposition={isComposition}
          isPresentation={isPresentation}
          hasComments={hasComments}
          componentId={componentId}
          isPreparePresentation={isPreparePresentation}
          indicatorsExplanation={indicatorsExplanation}
          hasExplanation={hasExplanation}
          inSlideView={this.props.inSlideView}
        />
        <div
          className={classnames(
            styles.BarometerAndValueComponent,
            styles.absolute_container,
            styles.flex_container,
            styles.align_container
          )}
        >
          {!this.props.inSlideView &&
            !this.props.isEmbedded && (
              <ComponentActions
                removeComponent={this.props.handleRemoveComponent}
                updateComponent={this.props.handleUpdateComponent}
                componentCase={this.props.ComponentCase}
                sideBar={"BarometerConfig"}
                component={"BarometerAndValueComponent.png"}
              />
            )}
          <span
            className={classnames(
              "medium-12 small-12",
              styles.flex_container,
              styles.align_container
            )}
          >
            <span className={classnames("medium-12 small-12")}>
              <img
                src={`/img/barometer_${
                  notAvailable ? "average" : barometerState
                }.svg`}
                alt={""}
              />
            </span>
            <span className={classnames("medium-12 small-12")}>
              <span className={styles.barometer_state}>
                {notAvailable ? _("notAvailable") : _(barometerState)}
              </span>
            </span>
          </span>

          <div
            className={classnames(
              "medium-12 small-12",
              styles.flex_container,
              styles.align_container
            )}
          >
            <span
              className={classnames("medium-12 small-12", styles.main_value)}
            >
              {notAvailable
                ? currentValue
                : number_format(currentValue, 2, ",", " ")}{" "}
              {unit !== "none" ? unit : ""}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default BarometerAndValueComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/BarometerAndValueComponent.js